import {
  Button,
  Checkbox,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Td,
  Tr,
  Tooltip,
  useToast,
  useDisclosure,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  VStack,
  Flex,
  Icon,
  Box,
  IconButton,
} from "@chakra-ui/react";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import CrmDataService from "../../services/data";
import ConfirmationModal from "../Modals/ConfirmationModal";
import { GoUnlink } from "react-icons/go";
import { RiCustomerService2Fill } from "react-icons/ri";
import { BsInfoCircleFill } from "react-icons/bs";
import { CloseIcon } from "@chakra-ui/icons";
import { PiNoteBold } from "react-icons/pi";
import { NoteModal } from "../Modals/NoteModal";
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";

const experts = [
  { label: "User1", value: "tamannarajpal" },
  { label: "User2", value: "mahi" },
  { label: "User3", value: "divanshi" },
];

const getExpertLabel = (value: string | undefined) => {
  const match = experts.find((e) => e.value === value);
  return match?.label || value;
};

export const LeadTableRow = ({
  el,
  setAction,
  setName,
  setPhoneNumber,
  setUserId,
  setAppUserId,
  setEmailVariables,
  selectedUser,
  setSelectedUser,
  selectedUserId,
  setSelectedUserId,
  page,
  pageId,
  appliedFilters,
  searchQuery,
  func,
  setFollowupLogData,
  setIsWhatsappUnavailable,
}: any) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];

  const {
    _id,
    user_information: { email, app_user_id, budget, issues },
    createdAt,
    original_entry_date,
    ehc_date,
    status,
    source,
    manual_status_override,
    // part_of_last_sync,
    // app_user_id,
    channel_unsubscribed,
    tracking_sources,
    marked_as,
    tag,
    assigned_expert,
    expert,
    whatsapp_unavailable,
    owner_note,
    note,
    last_followup,
  } = el;

  const [data, setData] = useState({
    location: "",
    budget: "",
    ehc: "",
    issues: [],
    manual_status_override,
  });

  const [phone, setPhone] = useState("");

  const [selectedStatus, setSelectedStatus] = useState("");

  const [channels, setChannels] = useState(channel_unsubscribed || {});

  const [enabledEmail, setEnabledEmail] = useState(null);

  const [tagValue, setTagValue] = useState(tag);

  const [waCheckBox, setWaCheckbox] = useState(whatsapp_unavailable);

  const [modal, setModal] = useState("");

  const followupDateTime = last_followup
    ? DateTime.fromISO(last_followup).setZone("local")
    : null;
  const followupDate = followupDateTime?.toFormat("yyyy-MM-dd") || "";
  const followupTime = followupDateTime?.toFormat("hh:mm a") || "";

  const openModal = (status: any) => {
    setSelectedStatus(status);
    onOpen();
  };

  const confirmStatusUpdate = () => {
    updateStatus(selectedStatus);
  };

  function calculateSystemAge(date: any) {
    let dateTime: DateTime;

    if (date instanceof Date) {
      dateTime = DateTime.fromJSDate(date);
    } else if (typeof date === "string") {
      dateTime = DateTime.fromISO(date);
    } else {
      // console.error("Unsupported date format");
      return "Invalid Date";
    }

    if (!dateTime.isValid) {
      console.error("Invalid date:", date);
      return "Invalid Date";
    }

    const date1Luxon = dateTime.startOf("day");
    const currentDateLuxon = DateTime.now().startOf("day");

    let diffInDays = currentDateLuxon.diff(date1Luxon, "days").days;
    if (diffInDays < 0) {
      diffInDays = 0;
    }

    return `${diffInDays.toLocaleString()} days`;
  }

  function isToday(dateInput: string | Date, zone: string = "utc"): boolean {
    let dateTime: DateTime;

    if (dateInput instanceof Date) {
      dateTime = DateTime.fromJSDate(dateInput, { zone });
    } else if (typeof dateInput === "string") {
      dateTime = DateTime.fromISO(dateInput, { zone });
    } else {
      return false;
    }

    if (!dateTime.isValid) return false;

    const today = DateTime.now().setZone(zone);

    return (
      dateTime.hasSame(today, "day") &&
      dateTime.hasSame(today, "month") &&
      dateTime.hasSame(today, "year")
    );
  }

  const updateStatus = (status: any) => {
    CrmDataService.updateStatus(_id, status).then((res) => {
      func();
    });
  };

  const updateChannels = (channels: any) => {
    CrmDataService.updateChannels(_id, channels).catch((error: any) => {
      console.log(error);
    });
  };

  const handleChannels = (channel: any) => {
    setChannels((prev: any) => {
      const updated = {
        ...prev,
        [channel]: !prev[channel],
      };
      updateChannels(updated);
      return updated;
    });
  };

  const handleTag = (tagValue: any) => {
    const data = { tag: tagValue };

    CrmDataService.updateCrmDataById(_id, data)
      .then(() => {
        setTagValue(tagValue);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const renderIcon = () => {
    switch (tagValue) {
      case "followup":
        return <FaCheck size={15} color="green" />;
      case "unfollow":
        return <IoClose size={20} color="maroon" />;
      default:
        return undefined;
    }
  };

  const handleNotOnWhatsapp = (e: any) => {
    const checked = e.target.checked;
    setWaCheckbox(checked);
    const waValue = checked ? true : false;

    const data = { whatsapp_unavailable: waValue };

    CrmDataService.updateCrmDataById(_id, data)
      .then((res) => {
        setIsWhatsappUnavailable(waValue);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const getUserDetails = (email: any) => {
    CrmDataService.getleaddetails(email, "", status)
      .then((res) => {
        const {
          data: {
            screening_information: { issues },
            client_information: { name, phone, languages_known, city },
            screening_result: { budget },
          },
        }: any = res.data;
        setData({ ...data, location: city, budget, issues });
        setName(name);
        setPhoneNumber(phone);
        setFollowupLogData({
          email,
          original_status: tracking_sources?.[0]?.status,
          current_status: status,
        });
        setPhone(phone);
        setAppUserId(app_user_id);
      })
      .catch((error: any) => {
        // toast({
        //   position: "top",
        //   title: "Fetch User Details Failed.",
        //   description: "User does not have an app user id",
        //   status: "error",
        //   duration: 500,
        //   isClosable: true,
        // });
        console.log(error);
      });
  };

  const maskEmail = (email: string) => {
    if (!email || !email.includes("@")) return "No email provided";
    const [localPart, domain] = email.split("@");

    const visibleLength = Math.max(0, localPart.length - 4);
    const visiblePart = localPart.slice(0, visibleLength);
    const maskedPart = "*".repeat(Math.min(4, localPart.length));

    return `${visiblePart}${maskedPart}@${domain}`;
  };

  const isDisabled = (type: any) => {
    const isMissing =
      type === "phone" ? !phone : type === "email" ? !email : !app_user_id;

    const isUnsubscribed =
      type === "phone"
        ? channels?.whatsapp
        : type === "email"
        ? channels?.email
        : channels?.app;

    return isMissing || isUnsubscribed;

    // if (type === "phone") {
    //   return !phone;
    // } else if (type === "email") {
    //   return !email;
    // } else {
    //   return !app_user_id;
    // }
  };

  useEffect(() => {
    setEmailVariables(data);
  }, [data]);

  useEffect(() => {
    setData({
      location: "",
      budget: "",
      ehc: "",
      issues: [],
      manual_status_override,
    });

    setEnabledEmail(null);
    setSelectedUser(null);
  }, [page, pageId, appliedFilters, searchQuery]);

  useEffect(() => {
    if (channel_unsubscribed) {
      setChannels(channel_unsubscribed);
    }
  }, [channel_unsubscribed]);

  useEffect(() => {
    setTagValue(tag);
  }, [tag, page, pageId]);

  return (
    <Tr
      bg={selectedUser === email ? "gray.200" : "white"}
      onClick={() => {
        getUserDetails(email);
        setEnabledEmail(email);
        setSelectedUser(email);
        setSelectedUserId(_id);
      }}
    >
      <Td
        // bg="red"
        style={{
          width: "380px",
          minWidth: "380px",
          maxWidth: "380px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        px={1}
        py={4}
        borderBottom="1px solid gray"
        cursor="pointer"
      >
        <Flex align="center" gap="1">
          {isToday(createdAt) && (
            <Text as="sub" color="violet" fontSize="xs" fontWeight="bold">
              (new)&nbsp;
            </Text>
          )}
          {marked_as && (
            <Text
              as="sub"
              color={marked_as === "urgent" ? "red.500" : "orange"}
              fontSize="xs"
              fontWeight="bold"
            >
              ({marked_as})&nbsp;
            </Text>
          )}
          {/* {maskEmail(email)} */}
          {email}
          <Tooltip
            label={<Text whiteSpace="normal">{note || "no remarks"}</Text>}
            placement="top"
          >
            <Box
              as="span"
              onClick={() => {
                // if (!selectedUserId) return; // simulate disabled
                setModal("notemodal");
                onOpen();
              }}
              // cursor={selectedUserId ? "pointer" : "not-allowed"}
              // opacity={selectedUserId ? 1 : 0.4}
              _hover={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
              _focus={{ boxShadow: "none" }}
              transition="all 0.2s"
              p={1}
              borderRadius="md"
            >
              <PiNoteBold size={14} color="#fdb508" />
            </Box>
          </Tooltip>
        </Flex>
      </Td>
      {modal === "notemodal" && (
        <NoteModal
          key={selectedUserId}
          isOpen={isOpen}
          onClose={onClose}
          id={selectedUserId}
          func={func}
          existingNote={note}
        />
      )}
      {accessControls.includes("salesAdmin") && (
        <Td
          px={1}
          borderBottom="1px solid gray"
          style={{
            width: "200px",
            minWidth: "200px",
            maxWidth: "200px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <Flex align="center" gap="1">
            <Tooltip
              label={
                <Text whiteSpace="normal">{owner_note || "no remarks"}</Text>
              }
              placement="top"
            >
              <span>
                <BsInfoCircleFill size={14} color="#fdb508" />
              </span>
            </Tooltip>
            {getExpertLabel(
              (assigned_expert === "expert4_tamannarajpal" && expert
                ? expert
                : assigned_expert || expert
              )?.split("_")[1] || "tamannarajpal"
            )}
          </Flex>
        </Td>
      )}
      {/* <Td px={1} borderBottom="1px solid gray">
        {data.location}
      </Td> */}
      <Td
        px={1}
        borderBottom="1px solid gray"
        style={{
          width: "100px",
          minWidth: "100px",
          maxWidth: "100px",
        }}
      >
        {budget}
      </Td>
      <Td
        px={1}
        borderBottom="1px solid gray"
        style={{
          width: "100px",
          minWidth: "100px",
          maxWidth: "100px",
        }}
      >
        <Text
          color={
            ["APP_EHC", "WEB_EHC"].includes(source) ? "teal.500" : "orange.300"
          }
          fontWeight="bold"
        >
          {["APP_EHC", "WEB_EHC"].includes(source) ? "yes" : "no"}
        </Text>
      </Td>
      <Td
        px={1}
        pr={10}
        borderBottom="1px solid gray"
        style={{
          width: "250px",
          minWidth: "250px",
          maxWidth: "250px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <Tooltip
          label={<Text whiteSpace="normal">{issues.join(", ")}</Text>}
          hasArrow
          placement="top"
          maxW="150px"
          isTruncated
        >
          <Text isTruncated>{issues.join(", ")}</Text>
        </Tooltip>
      </Td>
      <Td px={1} borderBottom="1px solid gray">
        {followupDate} {followupTime}
      </Td>
      {/* <Td px={1} borderBottom="1px solid gray">
        {calculateSystemAge(ehc_date || original_entry_date)}
      </Td> */}
      {/* <Td px={4} borderBottom="1px solid gray">
        <Checkbox
          checked={data.manual_status_override}
          onChange={(e) =>
            setData({ ...data, manual_status_override: e.target.checked })
          }
        />
      </Td>
      <Td
        px={4}
        style={{ width: "150px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Menu>
          <MenuButton
            as={Button}
            bg="white"
            border="1px solid gray"
            isDisabled={!data.manual_status_override}
          >
            Status
          </MenuButton>
          <MenuList>
            {["warm", "hot", "cold", "dead"].map((item) => (
              <MenuItem
                key={item}
                value={item}
                bg={status === item.toUpperCase() ? "#fdb508" : "white"}
                color={status === item.toUpperCase() ? "black" : "inherit"}
                _hover={{ bg: "#fdb508", color: "black" }}
                _focus={{ bg: "#fdb508" }}
                // onClick={() => updateStatus(item.toUpperCase())}
                onClick={() => {
                  openModal(item.toUpperCase());
                }}
              >
                {item.toUpperCase()}
              </MenuItem>
            ))}
          </MenuList>
          <ConfirmationModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={() => {
              confirmStatusUpdate();
              onClose();
            }}
          />
        </Menu>
      </Td> */}

      <Td
        px={2}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Checkbox
          colorScheme="red"
          icon={<Icon as={CloseIcon} />}
          isChecked={waCheckBox}
          onChange={handleNotOnWhatsapp}
        ></Checkbox>
      </Td>
      <Td
        px={2}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Options"
            icon={renderIcon()}
            size="xs"
            variant="outline"
            borderColor="gray.100"
          />
          <MenuList>
            <MenuItem onClick={() => handleTag("")}>Unmark</MenuItem>
            <MenuItem onClick={() => handleTag("followup")}>
              Mark for Followup
            </MenuItem>
            <MenuItem onClick={() => handleTag("unfollow")}>
              Mark for Unfollow
            </MenuItem>
          </MenuList>
        </Menu>
      </Td>
      <Td
        px={1}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Menu>
          <MenuButton
            as={Button}
            size="xs"
            bg="white"
            border="1px solid gray"
            disabled={enabledEmail !== email}
          >
            <RiCustomerService2Fill />
          </MenuButton>
          <MenuList minWidth="unset">
            <Tooltip
              label="no phone provided"
              isDisabled={!isDisabled("phone")}
              placement="right"
              hasArrow
            >
              <span>
                <MenuItem
                  isDisabled={isDisabled("phone")}
                  onClick={() => setAction("call")}
                  _hover={{ bg: "#fdb508", color: "black" }}
                  _focus={{ bg: "#fdb508" }}
                  value="call"
                >
                  Call/Chat
                </MenuItem>
              </span>
            </Tooltip>
            {accessControls.includes("admin") && (
              <Tooltip
                label="no phone provided"
                isDisabled={!isDisabled("phone")}
                placement="right"
                hasArrow
              >
                <span>
                  <MenuItem
                    isDisabled={isDisabled("phone")}
                    onClick={() => {
                      setAction("whatsapp");
                      setUserId(phone);
                    }}
                    _hover={{ bg: "#fdb508", color: "black" }}
                    _focus={{ bg: "#fdb508" }}
                    value="whatsapp"
                  >
                    WhatsApp Template
                  </MenuItem>
                </span>
              </Tooltip>
            )}
            <Tooltip
              label="no app userid provided"
              isDisabled={!isDisabled("app")}
              placement="right"
              hasArrow
            >
              <span>
                <MenuItem
                  isDisabled={isDisabled("app")}
                  onClick={() => {
                    setAction("notification");
                    setUserId(app_user_id);
                  }}
                  _hover={{ bg: "#fdb508", color: "black" }}
                  _focus={{ bg: "#fdb508" }}
                  value="notification"
                >
                  App Notification
                </MenuItem>
              </span>
            </Tooltip>
            <Tooltip
              label="no email provided"
              isDisabled={!isDisabled("email")}
              placement="right"
              hasArrow
            >
              <span>
                <MenuItem
                  isDisabled={isDisabled("email")}
                  onClick={() => {
                    setAction("email");
                    setUserId(email);
                  }}
                  _hover={{ bg: "#fdb508", color: "black" }}
                  _focus={{ bg: "#fdb508" }}
                  value="email"
                >
                  Email
                </MenuItem>
              </span>
            </Tooltip>
          </MenuList>
        </Menu>
      </Td>

      <Td
        px={1}
        style={{ width: "10px" }}
        borderBottom="1px solid gray"
        bg="#ffd46d"
      >
        <Popover placement="bottom-start" closeOnBlur={true}>
          <PopoverTrigger>
            <Button bg="white" border="1px solid gray" size="xs">
              <GoUnlink />
            </Button>
          </PopoverTrigger>
          <PopoverContent w="150px" p={2}>
            <PopoverBody>
              <VStack align="start" spacing={2}>
                <Checkbox
                  isChecked={channels.whatsapp}
                  onChange={() => handleChannels("whatsapp")}
                >
                  WhatsApp
                </Checkbox>
                <Checkbox
                  isChecked={channels.app}
                  onChange={() => handleChannels("app")}
                >
                  App
                </Checkbox>
                <Checkbox
                  isChecked={channels.email}
                  onChange={() => handleChannels("email")}
                >
                  Email
                </Checkbox>
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Td>
    </Tr>
  );
};
